
import Vue from "vue";
import axios from "axios";
import anime from 'animejs';
import TaskItem from '../Tasking/TaskItem.vue';

import { DashboardTasks, Tasks_Detail, 
        KeyValuePairOfIntegerAndString, TaskRoles, Tag } from '../../../types/Sapphire_dto';

export default Vue.extend({
  name: "dashboard-tasking",
  components: {
    TaskItem,
  },
    props: {
        title: {
            type: String,
            default: "Tasking/Appointments - Prev 7 Days"
        },
        pageSize: Number,
        // taskStatus: Array,
        // taskReasons: Array,
        // taskTimes: Array,
        // totalTaskCount: Number,
        // loading: Boolean,
        usr: String,
        fac: String
    },
    data: function () {
        return {
            tasks: [] as Tasks_Detail[],
            totalTaskCount: 0,
            currentPage: 1,
            selectedCat: null as Tag,
            selectedRole: null as TaskRoles,
            selectedType: null,
            taskTypes:  [
            { id: 1, name: "Task" },
            { id: 2, name: "Appointment" }
            ],
            taskLegend: [
                {
                    title: 'Appointment',
                    bgColor: '#5D4037'
                },
                {
                    title: 'Task',
                    bgColor: '#455a64'
                },
                {
                    title: 'Due Today',
                    bgColor: '#0aae1f'
                },
                {
                    title: 'Past Due',
                    bgColor: '#FDD835'
                }
            ],
            taskCategories: [] as Tag[],
            taskRoles: [] as TaskRoles[],
            taskStatus: [] as KeyValuePairOfIntegerAndString[],
            taskReasons: [] as KeyValuePairOfIntegerAndString[],
            taskTimes: [] as KeyValuePairOfIntegerAndString[],
            loading: false,
        }
    },
    // updated: function () {
    //     this.$nextTick(function () {
    //         // Code that will run only after the
    //         // entire view has been re-rendered
    //         sapphire.setupTippy();
    //     })
    // },
    watch: {
        selectedCat: 'filterTaskList',
        selectedRole: 'filterTaskList',
        selectedType: 'filterTaskList',
        currentPage: 'filterTaskList',
        fac: function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.filterTaskList();
            }
        },
    },
    methods: {
        async filterTaskList() {
            this.loading = true;
            try {
                const response = await axios.post("../../Common/Services/EhrTaskService.svc/GetDashboardTasks",
                {
                    facilityID: this.fac,
                    userID: this.usr,
                    onlyTasks: false,
                    pageNum: this.currentPage,
                    pageSize: this.pageSize,
                    category: this.selectedCat ? this.selectedCat.ID : 0,
                    role: this.selectedRole ? this.selectedRole.RoleID : 0,
                    taskType: this.selectedType ? this.selectedType.id :0
                });

                let dashTasks: DashboardTasks = JSON.parse(response.data.d);
                this.tasks = dashTasks.Tasks || [];
                this.totalTaskCount = dashTasks.TaskCount;

                this.taskCategories.length = 0;
                for (var i = 0; i < dashTasks.Tags.length; ++i) {
                    var currData = dashTasks.Tags[i];
                    this.taskCategories.push({
                        ID: currData.ID, Name: currData.Name,
                        FacGrpID: 0,
                        FacID: 0,
                        AddedOn: undefined,
                        AddedBy: 0,
                        Deleted: false,
                        ModifiedOn: undefined,
                        ModifiedBy: 0
                    });
                }
                
                this.taskRoles.length = 0;
                for (var j = 0; j < dashTasks.Roles.length; ++j) {
                    let roleData = dashTasks.Roles[j];
                    this.taskRoles.push({
                        RoleID: roleData.RoleID, 
                        RoleName: roleData.RoleName,
                        Active: false
                    });
                }

                this.taskStatus = dashTasks.Status;
                this.taskReasons = dashTasks.StatusReasons;
                this.taskTimes = dashTasks.TaskTimes;

            } catch (err) {
                //this.isErrored = true;
            }
            this.loading = false;
       },
        setTaskForEnter: function (el) {
            el.style.cssText = "opacity: 0; transform: translateY(-20px)";
        },
        taskEnter: function (el, done) {
            var tDelay = el.dataset.index * 150;
            anime({
                targets: el,
                opacity: 1,
                translateY: 0,
                easing: 'easeOutQuad',
                duration: 300,
                delay: tDelay,
                complete: function () {
                    done();
                }
            });
        },
        taskLeave: function (el, done) {
            var tDelay = el.dataset.index * 10;
            anime({
                targets: el,
                opacity: 0,
                translateY: '20px',
                easing: 'easeInQuad',
                duration: 100,
                delay: tDelay,
                complete: function () {
                    done();
                }
            });
        }
    }
});
